import {CssBaseline, GlobalStyles} from '@mui/material';
import {HashRouter} from 'react-router-dom';
import {ThemeContextProvider} from './context/ThemeContextProvider';
import {PageLayout} from './ui/PageLayout';
import AppStyles from './AppStyles.js'

function App() {

  return (
    <ThemeContextProvider>
      <HashRouter>
        <GlobalStyles styles={AppStyles}/>
        <PageLayout>
          <>
            <CssBaseline />
          </>
        </PageLayout>
      </HashRouter>
    </ThemeContextProvider>
  );
}

export default App;
